import { Servicio } from "./servicio";
import { HttpClient } from "@angular/common/http";
import { TipoOrdenCompra } from "../entidades/tipo-orden-compra";

export class ServicioTipoOrdenCompra extends Servicio<TipoOrdenCompra> {

    constructor(http: HttpClient) {
        super(http, "TiposOrdenCompra");
    }
}